export default {
  'notificationsMappingAttachments.title': 'Notificaciones / Mapeos Adjuntos',

  'notificationsMappingAttachments.form.source': 'Origen Adjunto',
  'notificationsMappingAttachments.form.attachmentName': 'Nombre Adjunto',
  'notificationsMappingAttachments.form.select.FormFieldAttachment': 'Formulario / Campo Adjunto',
  'notificationsMappingAttachments.form.select.GeneratedDocument': 'Documento Generado',
  'notificationsMappingAttachments.form.select.VariableAttachment': 'Variable / Tipo Adjunto',

  'notificationsMappingAttachments.form': 'Formulario',
  'notificationsMappingAttachments.field': 'Campo',
  'customNotifications.form.PDFTemplate': 'Formato',
  'customNotifications.form.Template': 'Plantilla',
  'customNotifications.form.variable': 'Variable',

  'notificationsMappingAttachments.mapping': 'Mapeo',
  'notificationsMappingAttachments.addMapping': 'Agregar mapeo',
  'notificationsMappingAttachments.noMappings': 'No hay mapeos configurados.',
};
